import { Box, Typography, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import type { JSX, ReactNode } from "react";

import { InfoIcon } from "@/assets";
import { EnhancedTooltip } from "@/components/enhancedTooltip";

interface PanelHeaderProps {
  title: string;
  titleAdornment?: ReactNode;
  description?: string;
  icon?: JSX.Element;
  rightContent?: ReactNode;
  tooltip?: {
    header?: string;
    content: string;
  };
}

export const PanelHeader = ({
  title,
  titleAdornment,
  description,
  icon,
  rightContent,
  tooltip,
}: PanelHeaderProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={theme.analysisLayout.titleGap}>
      <Stack direction="row" alignItems="center" spacing={theme.analysisLayout.titleGap}>
        {icon && <Box>{icon}</Box>}
        <Stack spacing={theme.analysisLayout.compactGap}>
          <Stack direction="row" alignItems="center" spacing={"12px"} flexWrap="wrap" useFlexGap>
            <Typography variant="widgetTitle">{title}</Typography>
            {titleAdornment}
            {tooltip && (
              <EnhancedTooltip header={tooltip.header} content={tooltip.content}>
                <Box sx={{ display: "flex" }}>
                  <InfoIcon sx={{ fontSize: theme.analysisLayout.titleFontSize, color: "primary.main" }} />
                </Box>
              </EnhancedTooltip>
            )}
          </Stack>
          {description && <Typography variant="panelDescription">{description}</Typography>}
        </Stack>
      </Stack>
      {rightContent}
    </Stack>
  );
};
